import {createContext, useEffect, useState} from "react";
import Sidebar, {SidebarTab} from "../../components/Sidebar";
import TechnologiesMap from "../../components/TechnologiesMap";
import {
  initialStateEsgDataIds,
  initialStateEsgFilters,
} from "./EsgDashboard.const";
import {DashboardContainer, TopBarContainer} from "./EsgDashboard.styles";
import getEsgFilteredData from "../../hooks/getEsgFilteredData";
import {IEsgDataIds, IinitialStateServerEsg} from "./EsgDashboard.type";
import SidebarCard from "../../components/SidebarCard";
import RadarChart from "../../components/RadarChart/RadarChart";
import SidebarInfo from "../../components/SidebarInfo";
import {ITypeRadar} from "../../types";
import {SidebarCardContainer} from "../../ui/SidebarCardContainer";
import {apiKeyDataEsg, urlApiDataEsg} from "../../helper/api";
import useFetchDataEsg from "../../hooks/useFetchDataEsg";
import {useQueryParam} from "../../hooks/useQueryParamEsg";

export const DataEsgIdsContext = createContext<any>(null);

const EsgDashboard = () => {
  const idEsg = useQueryParam("id");
  const typeRadar: ITypeRadar = "esg";
  const [activeSidebarTab, setActiveSidebarTab] = useState<SidebarTab>(
    SidebarTab.Empty
  );

  const [isVisibleFiltersPanel, setIsVisibleFiltersPanel] = useState(false);
  const [isOpenSearchPanel, setIsOpenSearchPanel] = useState(false);
  // const dataFromJson: IinitialStateServerEsg = JSON.parse(
  //   JSON.stringify(DataJson)
  // );

  const apiUrlProjects = `${urlApiDataEsg}/api/projects`;
  const apiUrlSegments = `${urlApiDataEsg}/api/segments`;

  if (!apiKeyDataEsg) {
    throw new Error("API key не тот");
  }

  const {projectsData, segmentsData} = useFetchDataEsg(
    apiUrlProjects,
    apiUrlSegments,
    idEsg ?? "",
    apiKeyDataEsg
  );

  const dataFromJson: IinitialStateServerEsg = {
    directions:
      segmentsData?.data.map((item) => {
        return {id: item.documentId, direction: item.name};
      }) || [],
    projects:
      projectsData?.data.map((item) => {
        return {
          id: item.documentId,
          name: item.name,
          cagr_tier: item.cagrTier,
          rank_tier: item.rankTier,
          market_forecast_tier: item.marketVolumeTier,
          direction_id: item.segment.documentId,
          project_description: item.description,
          cagr_lower_upper_bounds: item.cagrLowerBound,
          global_market_forecast_2030_bln_usd: item.irrUpperBound,
          gross_margin_lower_upper_bounds: " 1",
          irr_lower_upper_bounds: "1",
          project_size_lower_upper_bounds_mln_usd: "1",
          launch_period_lower_upper_bounds_years: "string",
          cost_and_demand_structure: "string",
          technological_advancements: "string",
          swot_analysis: "string",
          technology_readiness_level: 1,
          project_rank: 1,
          maturity_stage:
            item.maturity === "Высокая"
              ? "Продукт"
              : item.maturity === "Низкая"
              ? "Концепт"
              : "Прототип",
        };
      }) || [],
  };

  const searchDatasidebarInfo = {
    directions: dataFromJson.directions.map((item) => {
      return {id: item.id, name: item.direction};
    }),

    clusters: dataFromJson.projects.map((item) => {
      return {id: item.id, name: item.name, direction_id: item.direction_id};
    }),
  };

  const [isShowAllLabels, setIsShowAllLabels] = useState(false);
  const [isOpenPanel, setIsOpenPanel] = useState(false);
  const [isOpenSideBar, setIsOpenSideBar] = useState<boolean>(false);
  const [isOpenSideBarInfo, setIsOpenSideBarInfo] = useState<boolean>(false);
  const [isSearchPanelActive, setIsSearchPanelActive] = useState(false);
  const [filters, setFilters] = useState(initialStateEsgFilters);
  const [cpuStep, setCpuStep] = useState(1);
  const [activeTab, setActiveTab] = useState(SidebarTab.Esg);
  const [activeClusterId, setActiveClusterId] = useState<
    number | string | null | undefined
  >();
  const [activeDirectionId, setActiveDirectionId] = useState<
    number | string | null | undefined
  >();

  const radarData = getEsgFilteredData(dataFromJson, filters);

  const [dataIds, setDataIds] = useState<IEsgDataIds>(initialStateEsgDataIds);

  useEffect(() => {
    if (activeSidebarTab === SidebarTab.Directions) {
      setActiveTab(SidebarTab.Directions);
    }
    if (activeSidebarTab === SidebarTab.Projects) {
      setActiveTab(SidebarTab.Directions);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.CPU) {
      cpuStep === 1
        ? setActiveTab(SidebarTab.Projects)
        : setActiveTab(SidebarTab.CPU);
      setIsOpenSideBar(true);
    }
  }, [activeSidebarTab, cpuStep]);

  const openSidebarWithTab = (
    tab: SidebarTab,
    directionId: number | string,
    projectId?: number | string,
    projectTitle?: string,
    sectionName?: string,
    segmentColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar,
    isSearchPanelActive?: boolean
  ) => {
    setCpuStep(1);
    setActiveClusterId(projectId);
    setActiveDirectionId(directionId);
    setDataIds({
      directionId,
      projectId: projectId !== undefined ? projectId : null,
      projectName: projectTitle || "",
      directionName: sectionName || "",
      colorTitle: segmentColor?.back || "",
    });
    setActiveSidebarTab(tab);

    setIsOpenPanel(false);
    if (isSearchPanelActive) {
      setIsSearchPanelActive(true);
    } else {
      setIsSearchPanelActive(false);
    }
  };

  const resetToDefaultTab = () => {
    if (isSearchPanelActive) setIsOpenPanel(true);
    setTimeout(() => {
      setActiveSidebarTab(SidebarTab.Directions);
      setCpuStep(1);
      setActiveClusterId(null);
      setActiveDirectionId(null);
    }, 600);
    setIsOpenSideBar(false);
    setIsOpenSideBarInfo(false);
  };

  const toggleFilter: <T>(
    filter?: string,
    value?: T,
    isReset?: boolean
  ) => void = (filter, value, isReset = false) => {
    if (isReset) {
      setFilters(initialStateEsgFilters);
      return;
    }
    if (!filter) return;
    if (!(filter in initialStateEsgFilters)) return;
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      [filter]: {
        id: value !== undefined ? value : !prevFilters[filter],
        turnOn:
          value === undefined ||
          value ===
            initialStateEsgFilters[
              filter as keyof typeof initialStateEsgFilters
            ].id
            ? false
            : true,
      },
    }));
  };
  return (
    <DataEsgIdsContext.Provider value={{dataIds, setDataIds}}>
      <DashboardContainer>
        <Sidebar
          activeTab={activeTab}
          typeRadar="esg"
          setIsOpenSideBarInfo={setIsOpenSideBarInfo}
          isOpenSideBarInfo={isOpenSideBarInfo}
          searchDatasidebarInfo={searchDatasidebarInfo}
          setIsOpenPanel={setIsOpenPanel}
          isOpenPanel={isOpenPanel}
          openSidebarWithTab={openSidebarWithTab}
          onFilterChange={toggleFilter}
          filters={filters}
          isVisibleFiltersPanel={isVisibleFiltersPanel}
          setIsVisibleFiltersPanel={setIsVisibleFiltersPanel}
          isShowAllLabels={isShowAllLabels}
          setIsShowAllLabels={setIsShowAllLabels}
          setIsOpenSearchPanel={setIsOpenSearchPanel}
          isOpenSideBar={isOpenSideBar}
        />

        <SidebarCardContainer isOpenSideBar={isOpenSideBar}>
          <SidebarCard
            activeTab={activeSidebarTab}
            resetToDefaultTab={resetToDefaultTab}
            setActiveTab={setActiveSidebarTab}
            cpuStep={cpuStep}
            setCpuStep={setCpuStep}
            typeRadar="esg"
          />
        </SidebarCardContainer>

        <SidebarCardContainer isOpenSideBar={isOpenSideBarInfo}>
          <SidebarInfo typeRadar="esg" close={setIsOpenSideBarInfo} />
        </SidebarCardContainer>

        <TopBarContainer>
          <TechnologiesMap typeRadar={typeRadar} />
        </TopBarContainer>

        <RadarChart
          openSidebarWithTab={openSidebarWithTab}
          radarData={radarData}
          activeClusterId={activeClusterId}
          activeDirectionId={activeDirectionId}
          typeRadar="esg"
          isShowAllLabels={isShowAllLabels}
          isOpenSideBarInfo={isOpenSearchPanel}
        />
      </DashboardContainer>
    </DataEsgIdsContext.Provider>
  );
};

export default EsgDashboard;
